import React from 'react';
import Icon from '../../../components/AppIcon';

const ColorThemeSelector = ({ selectedTheme, onThemeSelect, className = "" }) => {
  const colorThemes = [
    {
      id: 'monochrome',
      name: 'Monochrome',
      description: 'Clean and minimalist',
      colors: {
        primary: '#374151',
        secondary: '#6B7280',
        accent: '#F3F4F6'
      },
      popular: true
    },
    {
      id: 'classic',
      name: 'Classic Blue',
      description: 'Professional and timeless',
      colors: {
        primary: '#1E3A5F',
        secondary: '#4A90A4',
        accent: '#E2E8F0'
      }
    },
    {
      id: 'warm',
      name: 'Warm Sunset',
      description: 'Energetic and inspiring',
      colors: {
        primary: '#D97706',
        secondary: '#F59E0B',
        accent: '#FEF3C7'
      }
    },
    {
      id: 'nature',
      name: 'Nature Green',
      description: 'Calm and refreshing',
      colors: {
        primary: '#059669',
        secondary: '#10B981',
        accent: '#D1FAE5'
      }
    },
    {
      id: 'elegant',
      name: 'Elegant Purple',
      description: 'Sophisticated and creative',
      colors: {
        primary: '#7C3AED',
        secondary: '#A78BFA',
        accent: '#EDE9FE'
      }
    },
    {
      id: 'coral',
      name: 'Coral Pink',
      description: 'Vibrant and modern',
      colors: {
        primary: '#FF6B6B',
        secondary: '#FF8E8E',
        accent: '#FFE5E5'
      }
    }
  ];

  return (
    <div className={`space-y-4 ${className}`}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {colorThemes?.map((theme) => (
          <div
            key={theme?.id}
            onClick={() => onThemeSelect(theme?.id)}
            className={`
              relative p-4 rounded-lg border-2 cursor-pointer transition-all duration-200
              hover:shadow-md hover:scale-[1.02]
              ${selectedTheme === theme?.id
                ? 'border-primary bg-primary/5 shadow-md'
                : 'border-border bg-card hover:border-primary/50'
              }
            `}
          >
            {theme?.popular && (
              <div className="absolute -top-2 -right-2 bg-accent text-accent-foreground px-2 py-1 rounded-full text-xs font-semibold">
                Popular
              </div>
            )}
            
            <div className="space-y-3">
              {/* Color Preview */}
              <div className="flex space-x-2">
                <div 
                  className="w-8 h-8 rounded-full border border-border"
                  style={{ backgroundColor: theme?.colors?.primary }}
                />
                <div 
                  className="w-8 h-8 rounded-full border border-border"
                  style={{ backgroundColor: theme?.colors?.secondary }}
                />
                <div 
                  className="w-8 h-8 rounded-full border border-border"
                  style={{ backgroundColor: theme?.colors?.accent }}
                />
              </div>
              
              <div>
                <h3 className="font-heading font-semibold text-foreground mb-1">
                  {theme?.name}
                </h3>
                <p className="font-body text-sm text-muted-foreground">
                  {theme?.description}
                </p>
              </div>
              
              <div className={`
                w-6 h-6 rounded-full border-2 flex items-center justify-center ml-auto
                ${selectedTheme === theme?.id
                  ? 'border-primary bg-primary' :'border-muted-foreground'
                }
              `}>
                {selectedTheme === theme?.id && (
                  <Icon name="Check" size={14} color="white" />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColorThemeSelector;